<div class="action-modal">
  <!-- HEADER -->
  <div class="modal-head">
    <span class="modal-head-icon"><mat-icon>undo</mat-icon></span>
    <div class="modal-head-text">
      <h1>Refund transaction</h1>
      <p class="modal-subtitle">
        @if (data.transaction.crossReference) {
          Ref {{ data.transaction.crossReference }}
        } @else {
          Return funds to the original card
        }
      </p>
    </div>
    <button
      mat-icon-button
      class="modal-head-close"
      (click)="cancel()"
      aria-label="Close"
      data-test="tx-refund-transaction-cancel-button"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- BODY -->
  @if (refundForm) {
    <div class="modal-body">
      <!-- Original transaction summary -->
      <section class="modal-section">
        <p class="section-label">Original payment</p>
        <div class="summary" data-test="tx-refund-summary">
          @if (data.transaction.maskedCard || data.transaction.last4Digits) {
            <div class="kv-row">
              <span class="kv-k">Card</span>
              <span class="kv-v">
                {{ data.transaction.maskedCard || '•••• ' + data.transaction.last4Digits }}
              </span>
            </div>
          }
          <div class="kv-row">
            <span class="kv-k">Paid</span>
            <span class="kv-v">
              {{ data.transaction.amount | currency: data.transaction.currencyCountry }}
              @if (data.transaction.createdOn) {
                <span class="text-muted"> on {{ data.transaction.createdOn | date: 'd MMM y' }}</span>
              }
            </span>
          </div>
          @if (data.transaction.amountRefunded) {
            <div class="kv-row">
              <span class="kv-k">Already refunded</span>
              <span class="kv-v">
                {{ data.transaction.amountRefunded | currency: data.transaction.currencyCountry }}
              </span>
            </div>
          }
          <div class="kv-row">
            <span class="kv-k">Available</span>
            <span class="kv-v kv-v-strong" data-test="tx-refund-remaining-amount">
              {{ remainingAmount | currency: data.transaction.currencyCountry }}
            </span>
          </div>
        </div>
      </section>

      <!-- Account to refund to -->
      <section class="modal-section">
        <p class="section-label">Refund to</p>
        <odin-account-selector
          [transaction]="data.transaction"
          label="Merchant account"
          testPrefix="tx-refund"
          (selectionChange)="onAccountSelected($event)"
        ></odin-account-selector>
      </section>

      <!-- Refund details -->
      <section class="modal-section">
        <p class="section-label">Refund details</p>
        <odin-dynamic-form [formData]="refundForm"></odin-dynamic-form>
        <div class="modal-note">
          <mat-icon>info_outline</mat-icon>
          <span>
            You can refund up to the amount still available on this payment.
            Partial refunds already processed reduce the available amount.
          </span>
        </div>
      </section>
    </div>
  }

  <odin-loading-spinner [active]="processing" [overlay]="true"></odin-loading-spinner>
</div>
